import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MyAuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  isLoggedIn = false;
  constructor(private authService: MyAuthService) {
    this.authService.userInfo.subscribe(LoggedIn => {
      this.isLoggedIn = (LoggedIn) ? true : false;
    });
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserLoggedIn();
  }
  checkUserLoggedIn() {
    return (this.isLoggedIn) ? true : false;
  }
}
